import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import type { IntegratedSalesSteps } from "../components/types";

interface IntegratedSalesState {
    currentStep: IntegratedSalesSteps;
}
export interface IntegratedSalesStore {
    integratedFlowsBySession: Record<string, IntegratedSalesState>;
    getCurrentStep(sessionId: string): IntegratedSalesSteps;
    updateIntegratedStep: (sessionId: string, step: IntegratedSalesSteps) => void;
    resetIntegratedStepStore: (sessionId: string) => void;
}

export const useIntegratedFlowStore = create<IntegratedSalesStore>()(
    persist(
        immer(
            devtools(
                (set, get) => ({
                    integratedFlowsBySession: {},
                    getCurrentStep: (sessionId: string) =>
                        get().integratedFlowsBySession[sessionId]?.currentStep || "SuggestedOfferStep",
                    updateIntegratedStep: (sessionId: string, step: IntegratedSalesSteps) => {
                        set(
                            (state) => {
                                const integratedSaleFlowStep = state.integratedFlowsBySession[sessionId] || {
                                    currentStep: step,
                                };
                                integratedSaleFlowStep.currentStep = step;
                                state.integratedFlowsBySession[sessionId] = integratedSaleFlowStep;
                            },
                            false,
                            "updateIntegratedStep",
                        );
                    },
                    resetIntegratedStepStore: (sessionId: string) =>
                        set(
                            (state) => {
                                delete state.integratedFlowsBySession[sessionId];
                            },
                            false,
                            "resetSteps",
                        ),
                }),
                {
                    enabled: import.meta.env.VITE_ENV_TYPE !== "production",
                    store: "integrated-flow-store",
                    name: "workspace/sales-tools",
                },
            ),
        ),
        { name: "integrated-flow-store", skipHydration: true },
    ),
);
